module.exports = __webpack_public_path__ + "media/images/homes/AccessRights-596a2a80a53064fccda1354c6eab0a83.png";